<template>
  <v-dialog :value="value" width="450" persistent>
    <v-card>

      <v-card-title>Filters</v-card-title>

      <v-card-text class="d-flex flex-column">

        <v-select v-model="filters.payment_method" label="Payment Method" :items="getCreditControlAccountsFilters.paymentMethods" hide-details outlined dense class="mb-4"></v-select>

        <v-select v-model="filters.last_dd_failed_reason" label="Last DD Failed Reason" :items="getCreditControlAccountsFilters.lastDDFailedReasons" hide-details outlined dense class="mb-4"></v-select>

        <v-menu v-model="lastPaymentMenu" :close-on-content-click="false" transition="scale-transition" offset-y class="mb-4">

          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="filters.most_recent_payment_date" label="Last Payment" v-bind="attrs" v-on="on" hide-details outlined dense readonly class="mb-4">

              <template #prepend-inner>
                <v-icon>{{ mdiCalendarBlank }}</v-icon>
              </template>
              
              <template v-if="filters.most_recent_payment_date.length" #append>
                <v-icon color="error" @click="clearLastPaymentDate">close</v-icon>  
              </template>

            </v-text-field>
          </template>

          <v-date-picker v-model="filters.most_recent_payment_date" range no-title width="400">
            <v-btn color="warning" small outlined @click="clearLastPayment">CLEAR</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" small @click="saveLastPayment">Ok</v-btn>
            <v-btn color="primary" small outlined @click="closeLastPayment">Cancel</v-btn>
          </v-date-picker>

        </v-menu>

        <v-select v-model="filters.status_reason" label="Status Reason" :items="getCreditControlAccountsFilters.statusReasons" multiple hide-details outlined dense class="mb-4"></v-select>

      </v-card-text>
      
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearFilter">CLEAR</v-btn>

        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submitFilter" class="mr-2">FILTER</v-btn>
        <v-btn color="primary" small outlined @click="closeFilter">CLOSE</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { mdiCalendarBlank } from '@mdi/js';

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        mdiCalendarBlank,

        filters: {
          payment_method: '',
          last_dd_failed_reason: '',
          most_recent_payment_date: [],
          status_reason: [],
        },

        lastPaymentMenu: false,
      }
    },

    computed: {
      ...mapGetters('creditControlDashboard', ['getCreditControlAccountsConfig', 'getCreditControlAccountsFilters']),
    },

    watch: {
      value(value) {
        if (value) {
          this.filters.payment_method = this.getCreditControlAccountsConfig.payment_method;
          this.filters.last_dd_failed_reason = this.getCreditControlAccountsConfig.last_dd_failed_reason;
          this.filters.most_recent_payment_date = this.getCreditControlAccountsConfig.most_recent_payment_date;
          this.filters.status_reason = this.getCreditControlAccountsConfig.status_reason;
        }
      }
    },

    methods: {
      ...mapActions('creditControlDashboard', ['updateCreditControlAccountsFilters']),

      clearLastPaymentDate() {
        this.filters.most_recent_payment_date = [];
      },

      clearLastPayment() {
        this.clearLastPaymentDate();
        this.closeLastPayment();
      },

      saveLastPayment() {
        if (this.filters.most_recent_payment_date.length) {
          this.filters.most_recent_payment_date = this.filters.most_recent_payment_date.sort();
        }
        this.closeLastPayment();
      },

      closeLastPayment() {
        this.lastPaymentMenu = false;
      },

      clearFilter() {
        this.filters.payment_method = '';
        this.filters.last_dd_failed_reason = '';
        this.filters.most_recent_payment_date = [];
        this.filters.status_reason = [];
      },

      async submitFilter() {
        await this.updateCreditControlAccountsFilters(this.filters);
        this.closeFilter();
      },

      closeFilter() {
        this.clearFilter();
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>